import { gql } from "@apollo/client";
export const checkoutMultiAthletePayments = gql`
mutation purchaseMemorabiliaMulti($athleteUserIds:[String!]!,$paymentFieldTokenId:String!,$paymentInfo:PaymentInfoInput!) {
purchaseMemorabiliaMulti(athleteUserIds:$athleteUserIds,paymentFieldTokenId:$paymentFieldTokenId,paymentInfo:$paymentInfo)
{status data}
}
`;
